/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import * as Sentry from "@sentry/angular";

import {isTesting, isProduction, appEnv} from "./app/utils/app_env";
import { environment } from "./environments/environment";

if (isTesting() || isProduction()) {
    let sampleRate = isProduction() ? 0.1 : isTesting() ? 1.0 : 0;

    Sentry.init({
        environment: appEnv(),
        release: environment.SENTRY_RELEASE,
        dsn: environment.SENTRY_DNS,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracePropagationTargets: ["testing-hexagon.gamelounge.com", "hexagon.gamelounge.com", "testing-hexagon.boostium.com", "testing-hexagon.kiickr.com"],
        // Performance Monitoring
        tracesSampleRate: sampleRate,
        // Session Replay
        replaysSessionSampleRate: 0, // Only record replays when an error occurs
        replaysOnErrorSampleRate: 1.0, // Record 100% of sessions where errors occur
        beforeSend(event) {
            if (event.message?.match(/Http failure response.*[45]\d\d/)) {
                return null;
            }
            return event;
        },
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
            'Non-Error promise rejection captured',
            /ChunkLoadError/,
            /Loading chunk/,
            'Failed to fetch',
            'NetworkError',
            'window.webkit.messageHandlers',
            '$ is not defined',
        ],
    });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
